import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class GridSwitchers extends ThemeComponent {
    @Prop threeColumns!: boolean;

    @Ref({required: false}) switchers!: HTMLButtonElement[];

    init() {
        // Init child switcher click event listener
        if (this.switchers) {
            for (const switcher of this.switchers) {
                this.$listen(switcher, 'click', () => this.handleGridUpdate(switcher));
            }
        }
    }

    handleGridUpdate(element: HTMLButtonElement) {
        // Do not continue if active element is clicked
        if (element.classList.contains('grid-swtichers__switcher--active')) {
            return;
        }

        // Toggle active switcher classes
        const switcherContainer = element.parentElement;
        const switchers = switcherContainer?.querySelectorAll('.grid-swtichers__switcher');
        if (switchers) {
            for (const switcher of switchers) {
                switcher.classList.toggle('grid-swtichers__switcher--active');
            }
        }

        // Get grid
        const grid = document.querySelector('.product-grid__products');
        if (!grid) {
            return;
        }

        // Determine if we are changing desktop or mobile classes
        let gridClasses = [];
        if (switcherContainer?.classList.contains('grid-switchers__desktop')) {

            // Define possible grid classes
            gridClasses = [
                'product-grid__products--four-columns',
                'product-grid__products--three-columns'
            ];
        } else {

            // Define possible grid classes
            gridClasses = [
                'product-grid__products--two-columns-mobile',
                'product-grid__products--one-columns-mobile'
            ];
        }

        // Remove old classes
        for (const gridClass of gridClasses) {
            grid.classList.remove(gridClass);
        }

        // Get and add class
        const classToAdd = element.getAttribute('data-grid-class-to-add');
        if (classToAdd) {
            grid.classList.add(classToAdd);
        }
    }
}
